import * as dayjs from 'dayjs';
import database from '../../model/firebase/firebase';

export const newsTypes = {
  CREATE_NEW: 'posts/CREATING_NEW_POST',
  EDIT_DATA: 'posts/EDITING_POST',
  REMOVE_NEWS: 'posts/REMOVING_POST',
  CURRENT_NEWS: 'posts/CURRENT_JOB',
  FETCH_POSTS_DATA: 'posts/GETTING_POST',
  REMOVE_JOBS: 'posts/REMOVE_JOBS',
};

export const setNewPost = (data) => ({
  type: newsTypes.CREATE_NEW,
  data,
});

export const currentPost = (data) => ({
  type: newsTypes.CURRENT_NEWS,
  data,
});

export const editPost = (changes) => {
  return { type: newsTypes.EDIT_DATA, changes };
};

export const removePost = (newValues) => ({
  type: newsTypes.REMOVE_NEWS,
  newValues,
});

export const getPosts = (newValues) => ({
  type: newsTypes.FETCH_POSTS_DATA,
  newValues,
});

export const loadPosts = () => async (dispatch, getState) => {
  const { auth } = getState();
  const { platform } = getState();
  const current = dayjs().valueOf();
  const posts = (
    await database
      .collection(`${platform.platformName}/data/posts`)
      .where('Status', '==', true)
      // .where("campusSegment","==",'all')
      // .where("campusSegment","===","")
      .orderBy('postDate', 'desc')
      .get()
  ).docs.reduce((acc, doc) => {
    const data = doc.data();
    const date = dayjs(data.expirationDate.seconds * 1000).valueOf();
    if (date >= current) {
      // console.log(!!data.campusSegment)
      if (auth.uid) {
        if (auth.claim === 'adminUser' || (!!data.campusSegment && data.campusSegment === 'all')) {
          acc.push(data);
        }
        // else if (!!data.campusSegment && data.campusSegment === student.profile.campusSegment) {
        //   acc.push(data);
        // }
      } else {
        acc.push(data);
      }
    }
    return acc;
  }, []);
  dispatch(getPosts(posts));
};

export const createNewPost = (payload = {}, isNew, action) => async (dispatch, getState) => {
    const {platform} = getState();
    const draft = action;
    const {
      postTitle,
      postSubTitle,
      Status,
      editBy,
      postDate,
      expirationDate,
      postBody,
      category,
      cardSize,
      likes,
      img,
      mode,
      tag,
      editorData,
      views,
      campusSegment,
    } = payload;
    const add = await database.collection(`${platform.platformName}/data/posts`).doc();
    const edit = await database.collection(`${platform.platformName}/data/posts`)
        .doc(payload.objectID === '' ? 'tempdID' : payload.objectID);
    const objectID = add.id;
    if (isNew) {
      const {objectID} = payload;
      const sendableEdit = {
        postTitle,
        postSubTitle,
        Status,
        editBy,
        postDate,
        expirationDate,
        postBody,
        category,
        cardSize,
        likes,
        img,
        draft,
        mode,
        tag,
        editorData,
        views,
        objectID,
        campusSegment,
      };
      await edit.update({ ...sendableEdit });
      dispatch(editPost({ ...sendableEdit }));
    } else {
      const sendableSave = {
        postTitle,
        postSubTitle,
        Status,
        editBy,
        postDate,
        expirationDate,
        postBody,
        category,
        cardSize,
        likes,
        img,
        objectID,
        draft,
        mode,
        tag,
        editorData,
        views,
        campusSegment,
      };
      await add.set(sendableSave);
      dispatch(setNewPost(sendableSave));
    }
  };
